<template>
  <el-card>
    <section>
      <!--工具条-->
      <el-col :span="24" class="form-line">
        <el-form size="small" :inline="true" :model="filters">
          <el-form-item label="车牌号">
            <el-input v-model="filters.licensePlate" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="营运证号">
            <el-input v-model="filters.operationLicenseNo" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="状态">
            <el-select v-model="filters.status" clearable placeholder="请选择">
              <el-option label="正常" :value="1"></el-option>
              <el-option label="禁用" :value="0"></el-option>
            </el-select>
          </el-form-item>
          <div style="float: right">
            <el-form-item>
              <el-button-group>
                <el-button type="primary" icon="el-icon-search" @click="getVehicleList()">查询</el-button>
                <el-button icon="el-icon-refresh-right" @click="resetFilter()">重置</el-button>
              </el-button-group>
            </el-form-item>
            <el-button size="small" icon="el-icon-plus" type="primary" style="max-resolution: 20px;" @click="handleAdd()">新增</el-button>
          </div>
        </el-form>
      </el-col>

      <!--列表-->
      <el-table border size="medium" :data="vehicleList" highlight-current-row v-loading="listLoading" @selection-change="selsChange">
        <el-table-column type="index" min-width="60">
        </el-table-column>
        <el-table-column prop="licensePlate" label="车牌号" min-width="120">
        </el-table-column>
        <el-table-column prop="operationLicenseNo" label="营运证号" min-width="150">
        </el-table-column>
        <el-table-column prop="operationLicenseStartDate" label="营运证开始日期" min-width="120">
        </el-table-column>
        <el-table-column prop="operationLicenseEndDate" label="营运证结束日期" min-width="120">
        </el-table-column>
        <el-table-column prop="vehicleLicenseStartDate" label="行驶证开始日期" min-width="120">
        </el-table-column>
        <el-table-column prop="vehicleLicenseEndDate" label="行驶证结束日期" min-width="120">
        </el-table-column>
        <el-table-column prop="compulsoryInsuranceDate" label="交强险有效日期" min-width="120">
        </el-table-column>
        <el-table-column prop="liabilityInsuranceDate" label="承运责任险有效日期" min-width="140">
        </el-table-column>
        <el-table-column prop="status" label="状态" min-width="80" :formatter="statusFormatter">
        </el-table-column>
        <el-table-column label="操作" min-width="120">
          <template slot-scope="scope">
            <el-button class="btn-text-pd0" size="mini" type="text" @click="handleEdit(scope.row.id)">编辑</el-button>
            <el-button class="btn-text-pd0" size="mini" type="text" @click="handleDel(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!--工具条-->
      <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="10"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          style="padding: 15px 5px">
      </el-pagination>

      <!--新增界面-->
      <el-dialog :title="messageTitle" :visible.sync="addFormVisible" :close-on-click-modal="false">
        <el-form size="small" :model="addForm" label-width="180px" :rules="addFormRules" ref="addForm">
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="车牌号" prop="licensePlate">
                <el-input v-model="addForm.licensePlate" auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="营运证号" prop="operationLicenseNo">
                <el-input v-model="addForm.operationLicenseNo" auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="营运证开始日期">
                <el-date-picker type="date"
                                placeholder="请选择开始日期"
                                value-format="yyyy-MM-dd"
                                v-model="addForm.operationLicenseStartDate"
                                style="width: 100%;">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="营运证结束日期">
                <el-date-picker type="date"
                                placeholder="请选择结束日期"
                                value-format="yyyy-MM-dd"
                                v-model="addForm.operationLicenseEndDate"
                                style="width: 100%;">
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="行驶证开始日期">
                <el-date-picker type="date"
                                placeholder="请选择开始日期"
                                value-format="yyyy-MM-dd"
                                v-model="addForm.vehicleLicenseStartDate"
                                style="width: 100%;">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="行驶证结束日期">
                <el-date-picker type="date"
                                placeholder="请选择结束日期"
                                value-format="yyyy-MM-dd"
                                v-model="addForm.vehicleLicenseEndDate"
                                style="width: 100%;">
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="交强险有效日期">
                <el-date-picker type="date"
                                placeholder="请选择日期"
                                value-format="yyyy-MM-dd"
                                v-model="addForm.compulsoryInsuranceDate"
                                style="width: 100%;">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="承运责任险有效日期">
                <el-date-picker type="date"
                                placeholder="请选择日期"
                                value-format="yyyy-MM-dd"
                                v-model="addForm.liabilityInsuranceDate"
                                style="width: 100%;">
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item label="营运证照片">
                <el-image class="object-contain" v-if="addForm.operationLicensePhoto!='' && addForm.operationLicensePhoto != null" :key="addForm.operationLicensePhoto" :src="addForm.operationLicensePhoto" alt="" :preview-src-list="addForm.operationLicensePhoto.split(' ')"></el-image>
                <img class="object-contain" v-if="addForm.operationLicensePhoto=='' || addForm.operationLicensePhoto == null" src="../../assets/img_defult.png" alt="">
                <el-upload
                    class="upload-demo"
                    :action="uploadUrl"
                    :on-change="handleChanges1"
                    :file-list="fileList"
                    list-type="picture" name="multipartFile" :multiple="true"
                    :before-upload="beforeAvatarUpload" :limit="1">
                  <el-button size="small" type="primary">点击上传</el-button>
                  <div slot="tip" class="el-upload__tip"></div>
                </el-upload>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="行驶证照片">
                <el-image class="object-contain" v-if="addForm.vehicleLicensePhoto!='' && addForm.vehicleLicensePhoto != null" :key="addForm.vehicleLicensePhoto" :src="addForm.vehicleLicensePhoto" alt="" :preview-src-list="addForm.vehicleLicensePhoto.split(' ')"></el-image>
                <img class="object-contain" v-if="addForm.vehicleLicensePhoto=='' || addForm.vehicleLicensePhoto == null" src="../../assets/img_defult.png" alt="">
                <el-upload
                    class="upload-demo"
                    :action="uploadUrl"
                    :on-change="handleChanges2"
                    :file-list="fileList"
                    list-type="picture" name="multipartFile" :multiple="true"
                    :before-upload="beforeAvatarUpload" :limit="1">
                  <el-button size="small" type="primary">点击上传</el-button>
                  <div slot="tip" class="el-upload__tip"></div>
                </el-upload>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="承运人险照片">
                <el-image class="object-contain" v-if="addForm.liabilityInsurancePhoto!='' && addForm.liabilityInsurancePhoto != null" :key="addForm.liabilityInsurancePhoto" :src="addForm.liabilityInsurancePhoto" alt="" :preview-src-list="addForm.liabilityInsurancePhoto.split(' ')"></el-image>
                <img class="object-contain" v-if="addForm.liabilityInsurancePhoto=='' || addForm.liabilityInsurancePhoto == null" src="../../assets/img_defult.png" alt="">
                <el-upload
                    class="upload-demo"
                    :action="uploadUrl"
                    :on-change="handleChanges3"
                    :file-list="fileList"
                    list-type="picture" name="multipartFile" :multiple="true"
                    :before-upload="beforeAvatarUpload" :limit="1">
                  <el-button size="small" type="primary">点击上传</el-button>
                  <div slot="tip" class="el-upload__tip"></div>
                </el-upload>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="状态">
                <el-select style="width: 100%" clearable v-model="addForm.status" placeholder="请选择">
                  <el-option label="正常" :value="1"></el-option>
                  <el-option label="禁用" :value="0"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click.native="addFormVisible = false">取消</el-button>
          <el-button size="small" type="primary" @click.native="addSubmit" :loading="addLoading">提交</el-button>
        </div>
      </el-dialog>
    </section>
  </el-card>
</template>

<script>
/* eslint-disable */
import {base, doPost, download} from "@/api/api";

export default {
  name: 'VehicleManagement',
  data () {
    return {
      uploadUrl: base + '/uploadFile/upload',
      fileList: [],
      filters: {
        licensePlate: '',
        operationLicenseNo: '',
        status: null
      },
      vehicleList: [],
      total: 0,
      listLoading: false,
      sels: [],
      addFormVisible: false,
      addLoading: false,
      addFormRules: {
        licensePlate: [
          { required: true, message: '请输入车牌号', trigger: 'blur' }
        ]
      },
      addForm: {
        licensePlate: '',
        operationLicenseNo: '',
        operationLicenseStartDate: '',
        operationLicenseEndDate: '',
        vehicleLicenseStartDate: '',
        vehicleLicenseEndDate: '',
        compulsoryInsuranceDate: '',
        liabilityInsuranceDate: '',
        operationLicensePhoto: '',
        vehicleLicensePhoto: '',
        liabilityInsurancePhoto: '',
        status: 1
      },
      editFlag: false,
      messageTitle: '',
      messageSuc: ''
    }
  },
  methods: {
    handleChanges1 (file, fileList) {
      if (fileList[0].status === 'success') {
        this.addForm.operationLicensePhoto = fileList[0].response.result
      }
    },
    handleChanges2 (file, fileList) {
      if (fileList[0].status === 'success') {
        this.addForm.vehicleLicensePhoto = fileList[0].response.result
      }
    },
    handleChanges3 (file, fileList) {
      if (fileList[0].status === 'success') {
        this.addForm.liabilityInsurancePhoto = fileList[0].response.result
      }
    },
    beforeAvatarUpload (file) {
      const isJPG = file.type === 'image/jpeg'
      const isLt10M = file.size / 1024 / 1024 < 10
      const isPNG = file.type === 'image/png'
      if (!isJPG && !isPNG) {
        this.$message.error('上传图片只能是JPG格式或PNG格式!')
      }
      if (!isLt10M) {
        this.$message.error('上传图片大小不能超过 10MB!')
      }
      return (isJPG || isPNG) && isLt10M
    },
    handleSizeChange (val) {
      this.filters.pageSize = val
      this.getVehicleList()
    },
    handleCurrentChange (val) {
      this.filters.pageNum = val
      this.getVehicleList()
    },
    resetFilter () {
      Object.assign(this.$data.filters, this.$options.data().filters)
    },
    getVehicleList () {
      this.loading = true
      doPost('/vehicle/getPageList', this.filters).then((res) => {
        console.log(res.result)
        this.total = res.result.total
        this.vehicleList = res.result.list
        this.loading = false
      })
    },
    handleDel: function (id) {
      this.$confirm('是否确认删除?', '提示', {
        type: 'warning'
      }).then(() => {
        this.loading = true
        var para = { id: id }
        doPost('/vehicle/deleteById', para).then((res) => {
          this.loading = false
          this.$message({
            message: '删除成功',
            type: 'success'
          })
          this.getVehicleList()
        })
      }).catch(() => {

      })
    },
    handleEdit: function (id){
      this.messageTitle = '修改'
      this.messageSuc = '修改成功'
      var para = {id: id}
      doPost('/vehicle/getById', para).then((res) => {
        this.addForm = res.result
        this.editFlag = true
        this.addFormVisible = true
      })
    },
    handleAdd: function () {
      this.editFlag = false
      this.addFormVisible = true
      Object.assign(this.$data.addForm, this.$options.data().addForm)
      this.messageTitle = '新增'
      this.messageSuc = '新增成功'
    },
    addSubmit: function () {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.$confirm('确认提交吗？', '提示', {}).then(() => {
            this.loading = true
            doPost('/vehicle/saveOrUpdate', this.addForm).then(res => {
              console.log(res)
              if (res.code === 200) {
                this.addFormVisible = false
                this.loading = false
                this.$message({
                  message: this.messageSuc,
                  type: 'success'
                })
                this.getVehicleList()
              }else{
                this.$message({
                  message: res.result,
                  type: 'error'
                })
              }
            })
          })
        }
      })
    },
    selsChange: function (sels) {
      this.sels = sels
    },
    statusFormatter (row, column) {
      if (row.status === 1) {
        return '正常'
      } else if (row.status === 0) {
        return '禁用'
      }
    }
  },
  mounted () {
    this.getVehicleList()
  }
}
</script>

<style scoped>
.vehicle-management {
  padding: 20px;
}

.object-contain {
  height: 160px;
  width: 100%;
  object-fit: contain;
  display: block;
  text-align: center;
}
.object-contain /deep/ .el-image__inner {
  object-fit: contain;
}
.object-contain /deep/ .el-image-viewer__close {
  color: #fff;
}
</style>
